export default "__VITE_ASSET__DMIryncT__"